import { createSlice } from "@reduxjs/toolkit";

type DrawerType = {
  open: boolean;
};
const initialState: DrawerType = {
  open: false,
};

const drawerSlice = createSlice({
  name: "drawer",
  initialState,
  reducers: {
    openDrawer: () => ({
      open: true,
    }),

    closeDrawer: () => ({
      open: false,
    }),
    clearDrawer: () => initialState,
  },
});

export const { openDrawer, closeDrawer, clearDrawer } = drawerSlice.actions;
export default drawerSlice.reducer;
